import { useEffect, useRef, useState } from "react";
import { Alert, Button, FormControl, FormGroup, OverlayTrigger, Popover } from "react-bootstrap";
import { Check2Square, Envelope, EnvelopeCheck, ExclamationTriangle } from "react-bootstrap-icons";
import { checkMobile, sendSMSOtp, setErrorDialog, translateError } from "../store/api/CommonFunctions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTable, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import ProgressBar from "./ProgressBar";
const COOLDOWN_MS = 2 * 60 * 1000;
const STORAGE_KEY = "otp_cooldown";
const PERSIAN_DIGITS = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
/**
 * 
 * @param {object} props 
 * @param {databaseEntities} props.entityType
 * @param {bigint} props.entityID
 * @param {string} props.externalPhoneNumber
 * @param {smsActions} props.smsAction
 * @param {function} props.onVerify
 * @returns 
 */
const PopSMSOtp = ({ title = "ارسال کد یکبار مصرف", entityType, entityID, externalPhoneNumber, smsAction, onVerify }) => {
    const [phoneNumber, setPhoneNumber] = useState(externalPhoneNumber);
    const [otp_userInput, setOtp_userInput] = useState(null);
    const [sendError, setSendError] = useState(null);
    const [sent, setSent] = useState(false);
    const [pending, setPending] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0);
    const timerRef = useRef(null);
    const dispatch = useDispatch();

    const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m.toString().replace(/\d/g, (d) => PERSIAN_DIGITS[d])}:${s.toString().padStart(2, "0").replace(/\d/g, (d) => PERSIAN_DIGITS[d])}`;
    };

    const handleSend = async () => {
        if (!(phoneNumber?.length > 10) || !checkMobile(phoneNumber)) {
            setSendError("شماره همراه معتبر نیست.");
            return;
        }
        setSent(true);
        const result = await sendSMSOtp({
            Action: smsAction,
            EntityID: entityID,
            EntityType: entityType,
            PhoneNumber: phoneNumber
        })
        setSent(false);
        if (result?.Message || result?.message) {
            setSendError(translateError(result.Message || result.message));
        }
        else if (result?.Data) {
            localStorage.setItem(STORAGE_KEY, Date.now());
            setTimeLeft(COOLDOWN_MS / 1000);
        }
    }
    const handleVerify = async () => {
        if (typeof onVerify === "function") {
            setPending(true);
            const result = await onVerify({
                Action: smsAction,
                EntityID: entityID,
                EntityType: entityType,
                PhoneNumber: phoneNumber,
                UserCode: otp_userInput,
            });
            if (result?.Message || result?.message) {
                setSendError(translateError(result.Message || result.message));
            }
            else if (result?.Data) {
                setErrorDialog(dispatch, "Success", "تایید کد");
            }
            setPending(false);
        }
    }
    const pop = (
        <Popover style={{ fontFamily: "Vazir" }}>
            <Popover.Title className="headerStyle">
                {title}
            </Popover.Title>
            <Popover.Content className="bodyStyle">
                {sendError && <Alert variant="danger">
                    <ExclamationTriangle size={23} /> {sendError}&nbsp;
                    <FontAwesomeIcon icon={faTimes} size="lg" style={{ float: "left" }} onClick={() => setSendError(null)} />
                </Alert>}
                {timeLeft > 0 ?
                    <>
                        <label className="w-100 text-center" style={{ fontSize: "11px", color: "blue" }}>{formatTime(timeLeft)} تا ارسال مجدد</label>
                        <FormGroup>
                            <label>کد دریافتی:</label>
                            <FormControl onChange={e => setOtp_userInput(e.target.value)} />
                            <Button className="mt-1 w-100" style={{
                                boxShadow: "2px 2px 4px black",
                                fontSize: "13px",
                                padding: "8px"
                            }}
                                variant="success"
                                disabled={pending}
                                onClick={handleVerify}>
                                <Check2Square size={18} /> تایید کد
                            </Button>
                        </FormGroup>
                    </> :
                    <>
                        <FormGroup>
                            <label>شماره همراه:</label>
                            <FormControl value={phoneNumber ?? ""} onChange={e => setPhoneNumber(e.target.value)} />
                        </FormGroup>
                        <Button className="mt-1 w-100" style={{
                            boxShadow: "2px 2px 4px black",
                            fontSize: "13px",
                            padding: "8px"
                        }} variant="info" onClick={handleSend} disabled={sent || timeLeft > 0}>
                            <EnvelopeCheck size={18} />&nbsp; ارسال کد</Button>
                    </>}
            </Popover.Content>
        </Popover>
    )

    useEffect(() => {
        const lastClick = localStorage.getItem(STORAGE_KEY);
        if (lastClick) {
            const diff = COOLDOWN_MS - (Date.now() - Number(lastClick));
            if (diff > 0) {
                setTimeLeft(Math.ceil(diff / 1000));
            }
        }
    }, []);

    // تایمر شمارش معکوس (یک بار ساخته می‌شود)
    useEffect(() => {
        if (timeLeft <= 0) return;

        if (!timerRef.current) {
            timerRef.current = setInterval(() => {
                setTimeLeft(prev => {
                    if (prev <= 1) {
                        clearInterval(timerRef.current);
                        timerRef.current = null;
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => {
            if (timerRef.current && timeLeft <= 0) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [timeLeft]);
    return (
        <OverlayTrigger overlay={pop} trigger="click">
            <Button className="group-Btn" ><Envelope size={18} /> {title}</Button>
        </OverlayTrigger>
    )
}
export default PopSMSOtp;